import type { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  children: ReactNode;
}

export function Button({
  variant = 'primary',
  className = '',
  children,
  ...rest
}: ButtonProps) {
  const cls = variant === 'primary' ? 'btn-primary' : 'btn-secondary';
  return (
    <button className={`${cls} ${className}`} {...rest}>
      {children}
    </button>
  );
}
